/* src/components/customGame/setup/CustomGameSidebar.js */
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCog,        // Global Settings
    faPuzzlePiece, // Stimuli (can also be faShapes, faCubes, faDiceD6)
    faRandom,     // Sequence Rules (can also be faSitemap, faProjectDiagram)
    faClock,      // Timing & Pacing
    faCommentDots,// In-Game Feedback (can also be faBullhorn)
    faKeyboard,   // Controls & Input
    faPollH,      // Results & Scoring (can also be faChartBar)
    faChevronRight // For active indicator or future sub-menus
} from '@fortawesome/free-solid-svg-icons';

// Define the categories and their properties
// For Phase 1, we'll include the main categories. Stimuli sub-categories can be handled later.
const sidebarCategories = [
    { key: 'global', label: 'Global Settings', icon: faCog },
    { key: 'stimuli', label: 'Stimuli', icon: faPuzzlePiece },
    { key: 'sequence', label: 'Sequence Rules', icon: faRandom },
    { key: 'timing', label: 'Timing & Pacing', icon: faClock },
    { key: 'feedback', label: 'In-Game Feedback', icon: faCommentDots },
    { key: 'controls', label: 'Controls & Input', icon: faKeyboard },
    // { key: 'results', label: 'Results & Scoring', icon: faPollH }, // Can be added in a later phase
];

const CustomGameSidebar = ({ activePanel, onPanelChange }) => {
    return (
        <aside className="w-64 bg-gray-800 text-white p-4 flex-shrink-0 h-full overflow-y-auto">
            <nav>
                <ul>
                    {sidebarCategories.map((category) => (
                        <li key={category.key} className="mb-1">
                            <button
                                onClick={() => onPanelChange(category.key)}
                                className={`
                                    flex items-center w-full text-left px-3 py-2.5 rounded-md text-sm font-medium
                                    transition-colors duration-150 ease-in-out group
                                    focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500
                                    ${
                                        activePanel === category.key
                                            ? 'bg-indigo-600 text-white font-semibold shadow-inner' // Active state
                                            : 'text-gray-300 hover:bg-gray-700 hover:text-white' // Inactive state
                                    }
                                `}
                                aria-current={activePanel === category.key ? 'page' : undefined}
                            >
                                <FontAwesomeIcon
                                    icon={category.icon}
                                    className={`
                                        mr-3 h-5 w-5 flex-shrink-0
                                        ${activePanel === category.key ? 'text-white' : 'text-gray-400 group-hover:text-white'}
                                        transition-colors duration-150 ease-in-out
                                    `}
                                    aria-hidden="true"
                                />
                                <span className="whitespace-nowrap flex-1">{category.label}</span>
                                {activePanel === category.key && (
                                    <FontAwesomeIcon icon={faChevronRight} className="h-3 w-3 ml-auto text-indigo-300" />
                                )}
                            </button>
                            {/* Placeholder for future sub-navigation, e.g., for Stimuli types */}
                            {/* {category.key === 'stimuli' && activePanel === 'stimuli' && (
                                <ul className="pl-6 mt-1 space-y-1">
                                    <li>Sub-item 1</li>
                                    <li>Sub-item 2</li>
                                </ul>
                            )} */}
                        </li>
                    ))}
                </ul>
            </nav>
        </aside>
    );
};

CustomGameSidebar.propTypes = {
    activePanel: PropTypes.string.isRequired,
    onPanelChange: PropTypes.func.isRequired,
};

export default CustomGameSidebar;